import { render, staticRenderFns } from "./Stage2.vue?vue&type=template&id=76c26f3b&scoped=true&"
import script from "./Stage2.vue?vue&type=script&lang=js&"
export * from "./Stage2.vue?vue&type=script&lang=js&"
import style0 from "./Stage2.vue?vue&type=style&index=0&id=76c26f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c26f3b",
  null
  
)

export default component.exports